import { createActionFactory } from '../../common/redux';
const { createAction, createApiFailureAction } = createActionFactory('Experience Workspace => Export Task => ');

//=============================================
// BOOTSTRAP PHASE
//=============================================
const bootstrapExportTasks = createAction('bootstrap export tasks', (experienceId, exportType) => ({
  experienceId,
  exportType,
}));
const bootstrapExportTasksSuccess = createAction('successfully bootstraped export tasks', (exportTask, exportType) => ({
  exportTask,
  exportType,
}));
const bootstrapExportTasksFailure = createApiFailureAction('failed to bootstrap export tasks');

//=============================================
// POLLING FOR EXPORT TASK
//=============================================
const startPollingExportTask = createAction('start polling last export', (experienceId, exportId, exportType) => ({
  experienceId,
  exportId,
  exportType,
}));
const stopPollingExportTask = createAction('stop polling last export', (exportType) => ({ exportType }));
const watchExportTaskPolling = createAction('watch for entry exports', (exportType) => ({ exportType }));
const completePollingExportTask = createAction('complete the export task', (exportType) => ({ exportType }));

//=============================================
// ADD A NEW EXPORT TASK
//=============================================
const generateNewExportTask = createAction('generate a new entry export', (exportType) => ({ exportType }));
const generateNewExportTaskSuccess = createAction(
  'successfully generated a new entry export',
  (exportTask, exportType) => ({
    exportTask,
    exportType,
  })
);
const generateNewExportTaskFailure = createApiFailureAction('failed to generate a new entry export', (exportType) => ({
  exportType,
}));

//=============================================
// FETCH THE LAST EXPORT
//=============================================
const fetchLastExport = createAction('get the last export', (experienceId, exportId, exportType) => ({
  experienceId,
  exportId,
  exportType,
}));
const fetchLastExportSuccess = createAction('successfully got the last export', (exportTask, exportType) => ({
  exportTask,
  exportType,
}));
const fetchLastExportFailure = createApiFailureAction('failed to get the last export', (exportType) => ({
  exportType,
}));

//=============================================
// DOWNLOAD THE EXPORT FILE
//=============================================
const downloadExport = createAction('download export file', (exportType) => ({ exportType }));
const downloadExportFailure = createAction('failed to download export file', (exportType) => ({ exportType }));

//=============================================
// ADDITIONAL LINKS
//=============================================
const previewData = createAction('preview the export data', (exportType) => ({ exportType }));
const previewDataSuccess = createAction('successfully previewed the export data', (exportType) => ({ exportType }));
const previewDataFailure = createAction('failed to preview the export data', (exportType) => ({ exportType }));

export default {
  bootstrapExportTasks,
  bootstrapExportTasksSuccess,
  bootstrapExportTasksFailure,

  downloadExport,
  downloadExportFailure,

  fetchLastExport,
  fetchLastExportFailure,
  fetchLastExportSuccess,

  generateNewExportTask,
  generateNewExportTaskSuccess,
  generateNewExportTaskFailure,

  previewData,
  previewDataSuccess,
  previewDataFailure,

  startPollingExportTask,
  stopPollingExportTask,
  watchExportTaskPolling,
  completePollingExportTask,
};
